import createContext from '../../utils/createContext';

export type ProductDetailContextT = {
  singleCTA: {
    enabled: boolean;
    showPriceSelectors: boolean;
    showPriceOnCTAs: boolean;
    priceOptionSelected: 'control' | 'neither' | 'guest' | 'member' | null;
    priceSelectorErrorCounter: number;
    incrementPriceSelectorError: () => void;
    setPriceOptionSelected: (value?: string) => string | null;
  };
};

export const [useProductDetailContext, ProductDetailContext] =
  createContext<ProductDetailContextT>('ProductDetailContext', {
    initialValue: {
      /**
       * PDP Single CTA feature
       * Displays Radio button options with a Member price and a Guest price
       * This selection affects and its value is used by other parts of the Product Detail Page
       */
      singleCTA: {
        enabled: false,
        showPriceSelectors: false,
        showPriceOnCTAs: false,
        priceOptionSelected: 'neither',
        priceSelectorErrorCounter: 0, // Incrementing it will scroll to the price selector and display an error
        incrementPriceSelectorError: () => {},
        setPriceOptionSelected: value => value,
      },
    },
  });
